import { useEffect } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useUserProfile } from 'core/hooks/data/useDataHook'
import AppLoadingIndicator from 'core/widgets/app-loader/AppLoadingIndicator'
import useNavigation from 'core/hooks/navigation/useNavigation'
import { useLocation } from 'react-router'
import { DashboardUrl, StartUrl } from 'constants/RouteUrls'
import APIService from 'api/APIService'
import useAuth from 'core/hooks/auth/useAuth'

const SltLoginPage = () => {
  const { push, replace } = useNavigation()
  const location = useLocation()
  const slt = new URLSearchParams(location.search).get('slt')
  const redirect_url = new URLSearchParams(location.search).get('redirect_url')
  const { setData } = useUserProfile()
  const { setUserId } = useAuth()
  const {
    isPending: isLoading,
    isError,
    mutate,
    data
  } = useMutation({
    mutationKey: ['stg-login'],
    mutationFn: APIService.users.login,
    onSuccess: (user) => {
      setUserId(user.token_id.toString())
      setData(user)
      setTimeout(() => {
        push(redirect_url || DashboardUrl)
      }, 2000)
    },
    onError: () => {
      setTimeout(() => {
        replace(StartUrl)
      }, 3000)
    }
  })
  useEffect(() => {
    if (slt) {
      mutate({
        single_login_token: slt,
        mixpanel_distinct_id: window?.mixpanel?.get_distinct_id?.()
      })
    }
  }, [mutate, slt])

  if (isLoading)
    return <AppLoadingIndicator overrideTitle="Logging you in..." />
  if (isError)
    return (
      <AppLoadingIndicator
        overrideTitle={
          <p>
            Unfortunately the token you provided was expired.
            <span className="mt-4 block  text-dark-4">
              Going back to login page...
            </span>
          </p>
        }
      />
    )
  if (data)
    return <AppLoadingIndicator overrideTitle={`Welcome back, ${data.email}`} />
  return null
}
export default SltLoginPage
